<div class="multi-select-chips-container">
	<div
		class="selector"
		[ngStyle]="{ width: selectWidth }"
	>
		<!-- Force recreation when showSelect flips -->
		<ng-container *ngIf="showSelect">
			<select
				[(ngModel)]="selectedValue"
				(change)="onSelect()"
				class="native-select want-error-border"
				[disabled]="disabled"
				[attr.aria-label]="'select inspection type' | i18next: { format: 'capitalize' }"
			>
				<option [value]="SELECT_INSPECTIONS_VALUE">{{ placeholder }}</option>
				<option
					*ngFor="let opt of unselectedOptions"
					[value]="toSelectString(opt.value)"
				>
					{{ opt.label }}
				</option>
			</select>
		</ng-container>
	</div>

	<div class="chip-container">
		<ng-container *ngIf="!defaultChips.length; else defaultChipsBlock">
			<mat-chip
				*ngFor="let chip of selectedOptions"
				removable
				(removed)="removeChip(chip)"
			>
				{{ chip.label }}
				<button
					matChipRemove
					class="chip-remove-btn"
				>
					<mat-icon>close</mat-icon>
				</button>
			</mat-chip>
		</ng-container>

		<ng-template #defaultChipsBlock>
			<mat-chip
				*ngFor="let chip of defaultChips"
				removable
				(removed)="removeChip(chip)"
			>
				{{ chip.label }}
				<button
					matChipRemove
					class="chip-remove-btn"
				>
					<mat-icon>close</mat-icon>
				</button>
			</mat-chip>
		</ng-template>
	</div>
</div>
